/* ============================================================
   GOD SELECTION XXX — Custom JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  console.log('[XXX] custom.js loaded');
});

// ─── Drawer stacking: last-opened drawer appears on top ───────
// Cart drawer z-index: var(--xxx-z-cart-drawer, 101)
// Header (contains menu drawer) z-index: var(--xxx-z-header, 100)
// Whichever opens last gets z-index 103; the other gets 101/100.
(function drawerStacking() {
  const root = document.documentElement;

  function bringCartFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '103');
    root.style.setProperty('--xxx-z-header', '100');
  }
  function bringMenuFront() {
    root.style.setProperty('--xxx-z-cart-drawer', '101');
    root.style.setProperty('--xxx-z-header', '103');
  }
  function resetStacking() {
    root.style.removeProperty('--xxx-z-cart-drawer');
    root.style.removeProperty('--xxx-z-header');
  }

  // Watch cart drawer active class
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(() => {
      if (cartDrawer.classList.contains('active')) {
        bringCartFront();
      } else if (!document.querySelector('#Details-menu-drawer-container[open]')) {
        resetStacking();
      }
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Watch menu drawer details[open]
  const menuDetails = document.querySelector('#Details-menu-drawer-container');
  if (menuDetails) {
    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.open) {
        bringMenuFront();
      } else if (!cartDrawer?.classList.contains('active')) {
        resetStacking();
      }
    });
  }
})();

// ─── Card: resolve the current destination URL for a card ────
// Returns the variant URL if a swatch is active, otherwise the plain product URL.
function cardDestUrl(card) {
  const variantUrl = card.dataset.xxxVariantUrl;
  if (variantUrl) return variantUrl;
  const link = card.querySelector('.card__heading a');
  return link ? link.getAttribute('href') : null;
}

// ─── Color Swatch: image swap + variant URL update ───────────
// Click on .xxx-swatch → swap the card image, update active state,
// and store the variant URL on the card for image-click navigation.
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.xxx-swatch');
  if (!swatch) return;

  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  e.preventDefault();
  e.stopPropagation();

  // Update active dot
  card.querySelectorAll('.xxx-swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');

  // Swap primary image
  const imgUrl = swatch.dataset.variantImage;
  if (imgUrl) {
    const img = card.querySelector('.xxx-card-img');
    if (img) {
      // Remove srcset/sizes so subsequent src changes always take effect
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imgUrl;
    }
  }

  // Store variant URL on card so image click can navigate to correct variant
  const variantId = swatch.dataset.variantId;
  if (variantId) {
    const baseLink = card.querySelector('.card__heading a');
    const baseUrl = baseLink ? baseLink.getAttribute('href').split('?')[0] : '';
    const variantUrl = baseUrl + '?variant=' + variantId;
    card.dataset.xxxVariantUrl = variantUrl;
    // Also update heading links so keyboard / right-click open-in-tab works correctly
    card.querySelectorAll('.card__heading a').forEach(a => a.setAttribute('href', variantUrl));
  }
});

// ─── Card image click → navigate to (variant) product page ───
// The full-card ::after overlay is disabled via CSS (pointer-events:none).
// This handler restores click-to-navigate on the product image only.
document.addEventListener('click', function (e) {
  const img = e.target.closest('.xxx-card-img');
  if (!img) return;

  const card = img.closest('.card-wrapper');
  if (!card) return;

  const url = cardDestUrl(card);
  if (url) window.location.href = url;
});

// ─── Undefined swatch detection ──────────────────────────────
// Adds .swatch--undefined to any swatch whose color variable resolves
// to an unrecognised CSS colour name. Uses a hidden test element to
// probe the browser's colour parser: valid colours produce a non-empty
// computed style; invalid ones produce an empty string.
(function markUndefinedSwatches() {
  const probe = document.createElement('div');
  probe.style.display = 'none';
  document.body.appendChild(probe);

  function isValidColor(value) {
    if (value.startsWith('url(')) return true; // image swatch (PNG from files)
    probe.style.backgroundColor = '';
    probe.style.backgroundColor = value;
    return probe.style.backgroundColor !== '';
  }

  function scan() {
    // Product detail page: Dawn .swatch with --swatch--background
    document.querySelectorAll('.swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--swatch--background').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });

    // Product cards: .xxx-swatch with --xxx-swatch-bg
    document.querySelectorAll('.xxx-swatch[style]').forEach(el => {
      const val = el.style.getPropertyValue('--xxx-swatch-bg').trim();
      if (val && !isValidColor(val)) el.classList.add('swatch--undefined');
      else el.classList.remove('swatch--undefined');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when new content is injected (e.g. quick-add, recommendations)
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();

// ─── Cart Exclusivity Guard: LIMITED ORDER vs in-stock ────────
// 受注生産商品(タグ "LIMITED ORDER") と 通常在庫商品 を
// 同一カートに混在させない。混在しそうな add-to-cart を捕捉して
// 確認モーダルを出し、ユーザー同意で既存カートをクリア → 追加し直す。
//
// 識別方法: LIMITED ORDER 追加時に hidden line item property
//   `properties[_limited_order]=1` を付ける。`_` プレフィックスは
//   Shopify がカートUIから非表示にする慣習。
//
// 仕組み: capture-phase の submit リスナでフォームを捕捉し、
//   product-form 配下なら preventDefault → /cart.js 確認 → 判定 →
//   問題なければ form.requestSubmit() で本来のハンドラに引き渡す。
(function cartExclusivityGuard() {
  const LIMITED_TAG = 'limited order';
  const LIMITED_PROP = '_limited_order';
  const BYPASS_KEY = '__xxxGuardBypass';

  function isLimitedTags(tagsStr) {
    if (!tagsStr) return false;
    return tagsStr.split(',').some(t => t.trim().toLowerCase() === LIMITED_TAG);
  }

  function cartIsLimited(cart) {
    return (cart.items || []).some(item => item.properties && item.properties[LIMITED_PROP]);
  }

  function ensureLimitedProperty(form, isLimited) {
    form.querySelectorAll('input[data-xxx-limited-marker]').forEach(el => el.remove());
    if (!isLimited) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + LIMITED_PROP + ']';
    input.value = '1';
    input.setAttribute('data-xxx-limited-marker', '');
    form.appendChild(input);
  }

  function resubmit(form) {
    form[BYPASS_KEY] = true;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      // 旧ブラウザフォールバック
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.click();
      else form.submit();
    }
  }

  function showModal(opts) {
    const addingLimited = opts.addingLimited;
    const existing = document.getElementById('xxx-cart-guard-modal');
    if (existing) existing.remove();

    const message = addingLimited
      ? 'こちらは受注生産商品のため、通常商品と同時にご注文いただけません。<br>カート内の通常商品を削除して、この受注生産商品を追加しますか?'
      : 'カート内に受注生産商品があります。<br>受注生産商品を削除して、こちらの商品を追加しますか?';

    const modal = document.createElement('div');
    modal.id = 'xxx-cart-guard-modal';
    modal.className = 'xxx-cart-guard__overlay';
    modal.innerHTML =
      '<div class="xxx-cart-guard__panel" role="dialog" aria-modal="true" aria-labelledby="xxx-cart-guard__title">' +
        '<h2 id="xxx-cart-guard__title" class="xxx-cart-guard__title">カートを切り替えますか?</h2>' +
        '<p class="xxx-cart-guard__message">' + message + '</p>' +
        '<div class="xxx-cart-guard__actions">' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--secondary" data-action="cancel">キャンセル</button>' +
          '<button type="button" class="xxx-cart-guard__btn xxx-cart-guard__btn--primary" data-action="confirm">カートを切り替える</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(modal);
    document.body.classList.add('xxx-cart-guard-open');

    function close() {
      modal.remove();
      document.body.classList.remove('xxx-cart-guard-open');
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) { close(); return; }
      const action = e.target.dataset && e.target.dataset.action;
      if (action === 'cancel') close();
      if (action === 'confirm') { close(); opts.onConfirm(); }
    });
    document.addEventListener('keydown', onKey);

    const focusBtn = modal.querySelector('[data-action="confirm"]');
    if (focusBtn) focusBtn.focus();
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    // 自身による再送信はスルー
    if (form[BYPASS_KEY]) { delete form[BYPASS_KEY]; return; }

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const addingLimited = isLimitedTags(productForm.dataset.productTags || '');

    // 非同期判定のため一旦遮断
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const hasItems = (cart.items || []).length > 0;
        const cartLimited = cartIsLimited(cart);
        const conflict = hasItems && (cartLimited !== addingLimited);

        if (!conflict) {
          ensureLimitedProperty(form, addingLimited);
          resubmit(form);
          return;
        }

        showModal({
          addingLimited: addingLimited,
          onConfirm: function () {
            fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
              .then(() => {
                ensureLimitedProperty(form, addingLimited);
                resubmit(form);
              })
              .catch(err => {
                console.error('[XXX Cart Guard] clear failed', err);
              });
          }
        });
      })
      .catch(err => {
        console.error('[XXX Cart Guard] cart fetch failed', err);
        // フォールバック: 判定失敗時はそのまま追加
        ensureLimitedProperty(form, addingLimited);
        resubmit(form);
      });
  }, true);
})();
